/* eslint-disable */
// export const Config = {
//   // apiUrl: (process.env.NODE_ENV == "production") ? "http://18.177.199.76/api/" : "http://192.168.1.205:8083/api/"
//   apiUrl: "http://192.168.1.205:8083/api/"
// };

// export const Config = {
//   apiUrl: "http://18.177.199.76/api/"
// };

// export const Config = {
//   apiUrl: "http://brain-appli-jeso5lhu7qnc-507598606.ap-northeast-1.elb.amazonaws.com/api/"
// };

// export const Config = {
//   apiUrl: "https://d3ki6ancorbiiz.cloudfront.net/"
// };

/* Development API */
// export const Config = {
//   apiUrl: "https://dev-api.brain100studio.com/api/"
// };

/* Test server */
// export const Config = {
//   apiUrl: "https://test-api.brain100studio.com/api/"
// };

/*GIRI server */
// export const Config = {
//   apiUrl: "http://192.168.1.40:8000/api/"
// };

export const Config = {
  apiUrl: process.env.VUE_APP_API_URL
};
